import Image from 'next/image'
import type { Engine } from '@/lib/ai/constants'
import { cn } from '@/lib/utils'

const ENGINE_LOGO_SRC: Record<Engine, string> = {
  chatgpt: '/images/ai-platforms/chatgpt-logo.svg',
  perplexity: '/images/ai-platforms/perplexity-logo.svg',
  gemini: '/images/ai-platforms/gemini-logo.svg',
  google_aio: '/images/ai-platforms/google-aio-logo.svg',
}

/** `chatgpt-logo.svg` is drawn in black; flatten it to white on dark surfaces (as the marketing logos do). */
const CHATGPT_DARK_MODE_CLASS = 'dark:brightness-0 dark:invert'

interface EngineLogoProps {
  engine: Engine
  size?: number
  className?: string
}

export function EngineLogo({ engine, size = 16, className }: EngineLogoProps) {
  return (
    <Image
      src={ENGINE_LOGO_SRC[engine]}
      alt=""
      width={size}
      height={size}
      style={{ height: size, width: 'auto' }}
      className={cn(engine === 'chatgpt' && CHATGPT_DARK_MODE_CLASS, className)}
    />
  )
}
